export const ns = ['common', 'frames'];
export const defaultNS = 'common';
import it from './it.json';
import en from './en.json';
import es from './es.json';

export const resources = {
  it,
  en,
  es,
};
